import {
  type ILogbookSignersData,
  type ISignerConfig,
  type ISignerRow,
} from "./LogbookSigners.types";

const mapSelectOptions = (
  items: any[],
  valueKey: string,
  labelKey: string,
): Array<{ value: string; label: string }> =>
  items.map(item => {
    if (typeof item === "string") {
      return { value: item, label: item };
    }
    return {
      value: String(item[valueKey] ?? item.value ?? item.lbid ?? ""),
      label: String(
        item[labelKey] ?? item.label ?? item.lbname ?? item.name ?? "",
      ),
    };
  });

export const mapGetSigners = (res: any): ILogbookSignersData => {
  const data = res?.data;
  const logbooks = mapSelectOptions(data.logbooks ?? [], "lbid", "lbname");
  const roles = mapSelectOptions(
    data.roles ?? data.ranks ?? [],
    "rolename",
    "rolename",
  );
  // The API may return signers flat (each row carrying its own lbid) or grouped
  // the same way `rowsToSavePayload` sends them. Flatten the grouped form back
  // into rows so the table renders either way.
  const raw: any[] = data.signers ?? data.list ?? [];
  const list: ISignerRow[] = raw.some(item => Array.isArray(item?.signers))
    ? raw.flatMap((group: any) =>
        (group.signers ?? []).map((signer: any) => ({
          ...signer,
          lbid: group.lbid,
        })),
      )
    : raw;

  return { logbooks, roles, rows: list };
};

export const rowsToSavePayload = (rows: ISignerRow[]) => {
  const grouped = new Map<string, ISignerConfig[]>();

  rows.forEach(row => {
    if (!row.lbid) return;

    const signer: ISignerConfig = {
      name: row.name,
      pri: row.pri ?? [],
      priMandatory: row.priMandatory ?? false,
      sec: row.sec ?? [],
      secMandatory: row.secMandatory ?? false,
    };

    if (row.id != null) {
      signer.id = row.id;
    }

    const existing = grouped.get(row.lbid) ?? [];
    existing.push(signer);
    grouped.set(row.lbid, existing);
  });

  return {
    list: Array.from(grouped.entries()).map(([lbid, signers]) => ({
      lbid,
      signers,
    })),
  };
};

export const emptySignerRow = (): ISignerRow => ({
  name: "",
  lbid: "",
  pri: [],
  priMandatory: false,
  sec: [],
  secMandatory: false,
});
